import filter from 'lodash/filter';
import head from 'lodash/head';

export const BRAND_NAMES = {
  keyngo: 'keyngo',
  goldcar: 'goldcar',
  europcar: 'europcar',
} as const;

export type AvailableBrands = keyof typeof BRAND_NAMES;

function checkBrandFromUrl(brand: AvailableBrands, hostname: string): boolean {
  return hostname.includes(brand);
}

export function getBrand(hostname?: string): AvailableBrands {
  const host = hostname ?? window.location.hostname;
  const brand = head(filter(Object.keys(BRAND_NAMES) as AvailableBrands[], (brandName) => checkBrandFromUrl(brandName, host)));
  return brand || BRAND_NAMES.keyngo;
}
